import { Component, OnInit, Input, Inject } from '@angular/core';
import * as _ from 'lodash';
import { ILdapTestResults, ILdapUserResult } from 'app/security/core/typings/ILdapTestResults';
import { ESortOrderType } from 'app/security/core/models/enum/security.enum';
import { Ldap } from 'app/security/core/models/ldap';
import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';
import { IFilterColumn } from 'app/scheduler/jobs/IFilterColumn';

@Component({
    selector: 'ldap-test-results',
    templateUrl: 'ldap-test-results.component.html',
    styleUrls: ['ldap-test-results.component.scss']
})

export class LdapTestResultsComponent implements OnInit {
    public ldapEnvironment : Ldap;
    public testResults : ILdapTestResults;
    public usersResults: Array<ILdapUserResult>;
    public sortColumnName: string;
    public sortOrderType: ESortOrderType;
    public columns: Array<IFilterColumn> = [];
    public paginatedTestResults : Array<ILdapUserResult>;
    public pageIndex = 0;
    public pageSize = 20;

    constructor(public modalComponentRef: BzgModalRef,
        @Inject(BZG_MODAL_DATA) public data: { ldapEnvironment: Ldap,
        testResults: ILdapTestResults }) {
        this.ldapEnvironment = data.ldapEnvironment;
        this.testResults = data.testResults;
        this.usersResults = this.testResults ? this.testResults.users : [];

        this.paginatedTestResults = this.usersResults.slice(this.pageIndex, this.pageSize);
    }

    ngOnInit() {
        this.columns.push({ key: 'samaccountname', value: 'samaccountname', visible: true, type: 'text' });

        _.forEach(Object.keys(this.ldapEnvironment.claims), (key) => {
            const claim = this.ldapEnvironment.claims[key];
            if(claim && claim !== '' && claim.trim() !== '') {
                let claimLowerCase = claim.toString().toLowerCase();
                this.columns.push({ key: claimLowerCase, value: claim, visible: true, type: 'text' })
            }
        });

        this.columns.push({ key: 'adspath', value: 'ADsPath', visible: true, type: 'text' })
    }

    public close() {
        this.modalComponentRef.close();
    }

    public sortByColumn(columnName: string, orderType: ESortOrderType) {
        this.sortColumnName = columnName;
        this.sortOrderType = orderType;

        switch (this.sortOrderType) {
            case 0:
                this.usersResults = _.orderBy(this.usersResults, [columnName], ['asc']);
                break;
            case 1:
                this.usersResults = _.orderBy(this.usersResults, [columnName], ['desc']);
                break;
            default:
                this.paginatedTestResults = _.orderBy(this.usersResults, [columnName]);
                break;
        }

        this.pageIndex = 0;
        this.paginatedTestResults = this.usersResults.slice(this.pageIndex, this.pageSize);
    }

    public onPaginationEvent(event) {
        const initialPosition = event.pageIndex * event.pageSize;
        const finalPosition = initialPosition + event.pageSize;
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;

        this.paginatedTestResults = this.usersResults.slice(initialPosition, finalPosition);
    }

}
